export { default } from './CapcaleraMunicipi';
